import Main from './StatementsMain'

const Statements = {
  Main,
}

export default Statements
